import * as React from 'react';

import { UitkIcon } from 'uitk-react-icons';
import { classNames } from 'uitk-react-utils';
import { AmenityViewModel } from 'models';
import { addIcon } from 'utils/amenity-mapper';

interface AmenitiesGridProps {
  amenities: AmenityViewModel[];
  moreAmenities?: boolean;
}

export const AmenitiesGrid: React.FunctionComponent<AmenitiesGridProps> = ({ amenities, moreAmenities = false }) => {
  const numOfAmenities = moreAmenities ? 12 : 4;
  const truncatedAmenities = amenities.slice(0, numOfAmenities);
  const amenityClasses = classNames('uitk-cell', 'all-b-margin-two', {
    'all-cell-1-2': !moreAmenities,
    'all-cell-1-4': moreAmenities
  });

  return (
    <React.Fragment>
      <ul className="uitk-type-list-300 icon-m uitk-grid">
        {truncatedAmenities.map((amenityWithoutIcon, index) => {
          const amenity = addIcon(amenityWithoutIcon);
          const amenityDescription = amenity.description;
          const amenityIcon = amenity.icon;
          const extraMargin = index === 0 ? 'all-t-margin-two' : '';

          return (
            <li className={amenityClasses} key={`amenity-${index}-${amenityDescription}`}>
              <div className="uitk-grid">
                <UitkIcon className={`uitk-cell all-cell-shrink ${extraMargin}`} id={`amenity-icon-${amenityIcon}`} name={amenityIcon} />
                <span className={`uitk-cell all-cell-fill ${extraMargin}`}>{amenityDescription}</span>
              </div>
            </li>
          );
        })}
      </ul>
    </React.Fragment>
  );
};
